export const settingsDeviceAttributesMessages = {
  en: {
    title: 'Device Attributes',
    addAttributeButton: 'Add attribute',
    deleteAttributesButton:
      'Delete {selectedRowsLength, plural, one {attribute} other {attributes}}',
    loadError: 'An error occurred while loading device attributes.',
    deleteNotification: 'Device attribute deleted',
    columns: {
      action: 'Action',
    },
    form: {
      validation: {
        snRequired: 'Serial number is required.',
        nameRequired: 'Attribute name is required.',
        nameInvalid:
          'Attribute name can contain only letters, numbers and _, must start with a letter and not end with _.',
        snNameDuplicate:
          'This serial number has already assigned custom value for that attribute.',
        valueRequired: 'Value is required.',
      },
      attribute: 'Attribute',
      value: 'Value',
      sn: 'Serial number',
      snDropdownTitle: 'Serial number / Hostname',
      hostnameUnknown: 'Unknown',
      cancel: 'Cancel',
      save: 'Save',
    },
    deleteRowsConfirmDialog: {
      btnSecondaryConfirm: 'Cancel',
      btnConfirm: 'Delete',
      header:
        '{count, plural, one {Attribute} other {# Attributes}} will be removed',
      subHeader:
        'Are you sure you want to remove the {count, plural, one {attribute} other {# attributes}}?',
    },
    docs: {
      url: 'URL',
      copyToClipboard: 'Copy to clipboard',
      copyToClipboardSuccess: 'Coppied to clipboard',
      setAttribute: 'Set attribute values',
      setAttributeDescription:
        'Adds attributes or updates them if given combination of serial number and attribute name is already set.',
      deleteAttribute: 'Delete attribute',
    },
  },
};
